module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_003.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Yeah, can you believe it? I cut myself shaving five times this morning! But, hey, enough about my petty problems. Let’s get going with Mrs. Felner’s cataract surgery.”")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_004.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“This playset cost more than our car, so we came up with a way to share the cost with three of our neighbors.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_006.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Hoping to convince management to provide a day-care center, employees at Gormley Industries staged a whine-in.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_007.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“It just goes to show ya—almost anything can be fixed with duct tape!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Relax. It’s just a can of paint I’m mixing up in the dryer.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_009.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Brian, this is Mrs. Smithers. From now on, she’ll be chaperoning you when you surf the Net.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_010.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_011.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Brad and Wendy would now like to share with you this sculpture, which they created as a symbol of their love and desire to spend as much time together as possible.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_012.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Quit babbling about whether or not it’s legal! Just run to the bank and get 50 dollars in quarters!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_013.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Just try to remain calm, Art. They can sense fear.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_014.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Great move callling in sick the last two days!\nEveryone in your office did a lottery pool yesterday.\nThey hit the Lotto for $27 million today!” ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_015.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Geesh! Check out the mug on\nthat poor little devil!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_016.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("On her flight from New York to Paris,\nPaula falls victim to a diaper scalper.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_017.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_018.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“The landlord won’t let us hang any pictures.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_019.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_020.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_021.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“OK, what’d you do with my\nbeer bottle collection?!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_022.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“How ironic is this? Here I am telling the president\nof one of the nation’s largest HMOs that the\nsurgery he needs isn’t covered by his insurance!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_023.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“This’ll just take a second. It was\nmy husband’s last request.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_024.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Cutting-edge technology for couch potatoes:\nfoot-activated remotes.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_025.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Watkins! Your blatant disregard for casual day\nis destroying morale around here! Either you\nchange into these clothes now, or we’ll find a\nposition for you down in the mail room!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_026.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Here’s an interesting piece of trivia.\nSince the baby was born, I’ve had 957 hours\nof sleep. You’ve had 1,429.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_027.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Joyce, get that idiot who gave the\nstress-management seminar on the phone!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_028.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“... and when a blade of grass grows high enough to\nbreak the beam of the electric eye, the power to your\nson’s stereo and computer will be instantly shut off.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_029.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“OK, Howard. We’ll play two more rounds\nusing the training clubs, and, if all goes well,\nyou’ll play your first solo round on Wednesday.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_030.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“It’s new. It’s called ‘The Days Remaining\nUntil School Starts Channel.’”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_031.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Don’t worry, Mr. Wincott. I’ll have that \nwisdom tooth out of there in no time!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_032.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("New technology for parents.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_033.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“OK, Mr. Cynic! Twenty-two years and four kids\nlater, it still fits! Pay up!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_034.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_035.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_036.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Mr. Ginsler, for the fifth time, when I get to the part where\nyou can object to the marriage, I will let you know!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_037.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“So you don’t like it. Big deal! You think\nI like spending two hours every day\nhelping you look for your car keys?!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_038.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Say, do you folks love a good mystery?\nIf so, this is the house for you!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_039.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“For cryin’ out loud, you idiot. I’m serious!\nI really have fallen and I can’t get up!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_040.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_041.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Didn’t anybody tell you? Fridays are casual day in\nthe O.R.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_042.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_043.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Dr. Johnson will be ready for you in just a minute.”")]), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_044.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The staff at Happy Hearts Day Care had its own unique way\nof penalizing parents who were late picking up their kids.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_045.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Hey, Virgil, come here! Check out the\ncheesy-looking toupee collection\nEl Dorko there is packing!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_046.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“It’s U.L. approved, plus it’s guaranteed\nfor up to 50,000 volts!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_047.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Urology department. Can you hold?”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_048.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Studies have revealed that 72 percent of all\nhousehold injuries are caused by adults trying\nto step over toddler safety gates.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_049.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“I told you folks over the phone that it’s\nan efficiency apartment.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_050.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“My, Helen, that certainly was\na strong contraction!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_051.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Here are the keys. The tank is full.\nYou have a great time tonight, big guy!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_052.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Doug and Romney get fired.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_053.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“You’ll be happy to know that the plane landed\nsafely. I "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("said")]), _vm._v(", the plane landed safely."), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v(" Hello")]), _vm._v("?!”\n")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_054.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_055.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“For an additional one dollar per ticket, would you\nlike to buy disability insurance?”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_056.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“OK, now here’s your horoscope! ‘Romance and\nadventure are yours for the taking! Today’s the\nday to tackle that big project you’ve been\ndying to get at.’”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_057.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Is that thing locked up again? You need to\nsmack the side of the CPU while simultaneously\nhitting the ‘T’ key as fast as possible.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_058.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Let me get this straight. You’re going to build us a\nwraparound front porch using skills gleaned\nsolely from watching old episodes of\n‘Home Improvement’?”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_059.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“That mower comes with a case of your favorite beverage.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_060.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Freak shows for parents.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_061.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“One, it’s at "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("least")]), _vm._v(" three miles away! Two, there’s only\na 40 percent chance that it’ll come this way. Three,\nI’m two under par through 12 holes!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_062.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“It’s called Pompeii Disease. It’s not serious, but\nI suggest you wear old clothes for the next\ncouple of weeks.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_063.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Would it kill you to spend 15 bucks on a\nlawn sprinkler?!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_064.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“The cable company added ‘The Croquet Channel,’\n‘The Hygiene Channel,’ and ‘The Potato Network.’\nThey raised their rates $15.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_065.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“For the last 45 minutes he’d been raving about\nwhat incredible TV reception we were getting,\nand then ‘Wham!’”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_066.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Ma’am, I’m new on the job today. Could you\ntake a photo of your husband and me as I issue\nmy very first speeding ticket?”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_067.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“OK, Vern! Danny and I are going to flush the roaches toward you!\nGet ready to dance ‘La Cucaracha’!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_068.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“I hope you don’t mind if we stop in here until that rain lets up.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_069.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Well, what’d you expect?! I’ve been telling you\nfor two years that we need health insurance!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_070.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_071.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("In their never-ending quest to cut overhead costs,\nmany companies are turning to the new\nmicro-cubicles.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_072.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("The affordable and increasingly popular\nface-lift clip.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_073.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“OK, today we test your reflexes.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_074.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Booth No. 1 will be available in about seven\nminutes. I’m cooking a TV dinner in there.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_075.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_076.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_077.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“How do you feel about alternative medicine?”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_078.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Isn’t that pop-up book just the cutest thing?”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_079.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Every September, school buses everywhere incur\nmillions of dollars of damage by souvenir-scavenging\nparents of kindergartners.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_080.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Well, that pretty much wipes out my tips\nfor the evening.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_081.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Relying on his vast CD collection, manager\nWalt Friboski liked to provide an appropriate\nsoundtrack when he gave performance reviews.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_082.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“OK, Captain Anxiety. I took some Polaroids\nbefore we left. Exhibit A: the stove with all burners\nclearly in the ‘off ’ position. Exhibit B: the back door\nwith it’s deadbolt latched. Exhibit C: my curling\niron unplugged ...”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_083.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Oh, I see! So it’s "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("my ")]), _vm._v("fault that a butterfly darted in front of the\ncar and I had to slam on the brakes, is that it?!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_084.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Well, how do you like my new system for making sure\nmy tools get returned?”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_085.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_086.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_087.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Ma’am would you mind wearing this for about 10\nminutes? We’re going to play a little prank on the\ngentleman sleeping in the seat in front of you!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_088.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“OK, free HBO! Come to Papa!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_089.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“The idea gave me the creeps at first, but when\nFrank showed me the numbers I had to admit that\nselling burial plots in our yard is a great way to\nput the kids through college.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_090.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“I’m curious. Why is this technique called the Holyfield Maneuver?”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_091.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Tell me again how much money we’re saving by cutting our own firewood!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_092.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_093.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("With baby-sitters in short supply, the Cranstons shrewdly installed Mr. Eye"), _c('sup', [_vm._v("®")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_094.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Chuck considered the interview to be over after the job applicant consulted her Magic Eight Ball"), _c('sup', [_vm._v("®")]), _vm._v(" to answer three consecutive questions.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_095.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_096.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Denise is able to avert yet another disaster thanks to her Toddler Retrieval System.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_097.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“It’s the latest version of the stress test. We’ll monitor your heart rate as you try to feed these seven hungry babies with just one bottle.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_098.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Gina, before you make the biggest mistake of your life, I want you to meet Esther Baumgarten’s son, Rudy. Rudy is assistant manager of Pizza Baron, "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("and")]), _vm._v(" he plays the clarinet!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_099.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_100.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Though they hadn’t even stepped inside yet, veteran real estate agent Clair Gelt knew the sale was in the bag.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_101.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Will you shut up about how great the fishing is?!” ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_102.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Thanks to the innovative labs of teacher Herb Krenley, physics quickly became Westvale High’s most popular course.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_103.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_104.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("By the time he turned thirteen, Bryan was starting to see through his father’s little scam.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_105.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Todd’s relationship with management improved dramatically once he started bringing his new pet to work.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_106.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“We’re going to try to disintegrate the kidney stone with a three-hour barrage of music by the rock band Pearl Jam.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_107.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_108.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Well, hon, it took $1,400 and 57 hours of hard labor, but we did it!"), _c('br'), _vm._v("\nI can’t wait to see the looks on the kids’ faces!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_109.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Oh, that. I got it from the Healthy Lifestyles catalog. It automatically dispenses a dab of sunscreen anytime someone leaves the house.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_110.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Jason proves that he wasn’t lying about the fate of his homework.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_111.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Tiger Woods: the early months.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_112.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Trish realizes she has just entered into a lifetime\nwith a chronic do-it-yourselfer.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_113.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Serenity Noelle! The name we want on the birth \n  certificate is Serenity Noelle Wagner! Write it \ndown! "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("Write it down, I said!”")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_114.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“It’s so vintage Ray! When he got a riding mower, he had to have the one with the built-in TV and back massager. When we picked out a dog, he tested them all to see which one had the highest IQ.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_115.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“And remember this time, Bobby! Number each item as it comes out so we’re sure it goes back in the right order!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_116.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_117.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Evolving through centuries of picking up table scraps, the Hoover Hound has come to play an important role in many households.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_118.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Mr. Hopkins! We’re having a bit of trouble with the new laser printer.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_119.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Bizarre though it was, the Merkles had stumbled onto a system for picking stocks that netted them $11,761 in just five months.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_120.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("As soon as they got onto the bus, Roger and\nGlenda had an unshakable sense of foreboding.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_121.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“I see one! I see a rest room! There’s a woman coming out ... it looks clean in there ... no sign of flies ...”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_122.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“OK, folks! It’s time to find out which of these\nlovely, single gals will be the lucky one\nto catch the bouquet!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_123.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_124.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Knock it off, Carlos! Remember, we agreed that Isabelle would choose her own day-care provider.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_125.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_126.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Look at that, everyone! Annette was able to walk right past the computer "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("even though she knows")]), _vm._v(" there are 27 e-mails waiting for her!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_127.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“You heard me, Mendrick!\nNo hands or feet allowed!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_128.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Well, Mr. Floor-It-We-Can-Make-It, do you "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("still")]), _vm._v(" want me to rush home so you don’t miss the Packers game?”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_129.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“It’s constructed out of the same soundproofing material that NASA uses on the space shuttle, "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("and")]), _vm._v(" it’s hypoallergenic.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_130.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_131.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_132.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“First, the 900-square-foot heated tree fort. Then the fully operational backyard planetarium. And now this. It’s all a well-orchestrated plot to make us look like the world’s lousiest parents.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_133.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Eh, eh, eh! You know the rules! No bugging Mom at work!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_134.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“I’m tellin’ ya! Ever since you rigged up that smoke machine under the table, I just can’t "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("wait")]), _vm._v(" to get to work every day!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_135.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“1,200 hits a day?! Big deal! My Web site averages 18,000 hits a day!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_136.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Through well-planned provocation, Vince was able to harvest enough toilet paper during Halloween to keep the family supplied for an entire year.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_137.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Whenever one of his daughters returned from a date, Mr. Shelburne would carefully dust her for fingerprints.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_138.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“The doctor says she’ll grow into her tongue.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_139.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Mix five grams of potassium nitrate with three milliliters of sodium chloride, add a dab of nail polish, and then rub it on your stomach.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_140.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“With your gingivitis flaring up again, I figured it was a good idea to invest in a power flosser.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_141.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Barry does his trick of clenching all his muscles at once and getting his I.V. bag to expand.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_142.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("With just three days until Halloween, the kids of Maple Avenue had their surveillance teams in place.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_143.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("The fake rubber leg that Diane kept in her purse livened up many a first date.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_144.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("After debuting its new weather format, TV 52’s ratings soared to No. 1.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_145.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Before giving out candy, the Gernsteads required that trick-or-treaters first watch a short video on dental care.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_146.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“When I was a kid, we had to get up, walk clear across the room, and turn a dial on the TV whenever we wanted to change the channel.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_155.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Well, there’s a good one to know about. ‘Stereo ... receiver"), _c('br'), _vm._v("\n  ... needs ... to be ... moved up ... higher.’”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_156.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_157.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Oooooh, this is exciting! Our first practical application for the Internet! OK, should I do a search under ‘pythons,’ ‘snakes’ or ‘suffocation’?”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_158.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Bill’s away for two weeks, and he made me swear not to let the baby take her first steps until he’s home to see the big event.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_159.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("The year the SAT creators decided to mess with students’ minds.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_160.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“The face-lifting technique we’ll be performing on you is somewhat controversial. So just to be on the safe side, we want to try it on this lab rat first.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_161.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“I knew we were in trouble the second he yelled that old ‘Look, Ma, no hands!’ line.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_162.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Thanks to their new aromatic spray bottles, the Girl Scouts experienced a 147 percent increase in cookie sales.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_163.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“We should have gotten off the plane the second we overheard the pilot say he’s an ex-Blue Angel.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_164.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_165.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_166.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“One minute I was checking out Web sites on spaying and neutering pets, the next minute ...”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_167.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Yet another technological advancement for couch potatoes.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_168.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Alex Trebek’s secret moonlighting job.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_169.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Having successfully completed her shopping without a major tantrum, Linda now had to run the harrowing gauntlet of toy and candy dispensers.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_170.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Well now! Maybe the next time I tell you that the car is making a funny rattling noise, I won’t get one of your condescending smirks!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_171.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“A new technique? Hey, whatever. I’ll try anything to get rid of this killer headache.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_172.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_173.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“There are two divergent opinions on how best to treat you. I’m convinced you need a triple bypass.Your HMO says all you need to do it rub this $14 tube of salve on your chest.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_174.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Whoa, hold up, Bert! What do we have here in the back seat?! A little book titled "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("How to Sweet-Talk Your Way out of Any Speeding Ticket")]), _vm._v("!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_175.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Mr. Hagy couldn’t resist pulling out his remote-control frog at least once a year.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_176.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Knowing that her manager would never allow her to leave early to watch her son’s soccer game, Wendy hires a body double.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_177.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Oh, yeah, now I remember. The roofing contractor left a message saying you should call him ASAP.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_178.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("The Gilmonts play a tension-filled game of chore poker.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_179.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_181.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Well, at last we have a volunteer to do the oral report on quantum physics.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_182.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Yeah, well, where’s Kathie Lee now?!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_183.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“OK, Mr. Morris. I need to have you scoot as far to your left as possible.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_184.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Isn’t genetic engineering amazing? Two years ago who would have even imagined such a thing as a Turkipede?!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_185.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("With the electricity out and their emergency generator able to power only the stove or the TV, tensions in the Normont household were at a fevered pitch.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_186.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_187.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_189.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Aw, come on, Mr. Sinclair! Don’t be such a gloomy Gus! A little friendly athletic competition will do wonders for your spirits! I’ll be your cheerleader!”\n")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_190.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Scandal rocks the whale-watching industry.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_191.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_192.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Guess how many stitches you’ve got, within three, and we’ll take 10 percent off your bill!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_193.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Well I’ll be! Sheila, it’s "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("another")]), _vm._v(" electronic listening device! Santa’s helpers must have bugged our house to see who’s being naughty or nice!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_194.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Cosgrove, get back here!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_195.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("While Jack kept the Watkinses distracted in the kitchen, Muffy combed their house for their secret black book of baby-sitters.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_196.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Sorry about this, Carol. I was positive that the door at the back of the theater was an exit.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_197.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Having passed the state’s driver exam, Tammy now had to pass her father’s grueling 12-part version.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_198.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Sorry, but the life preserver is required by our insurance company.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_199.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Hoping to break out of their traditional mold, the Mormon Tabernacle Choir performs the barking dogs version of “Jingle Bells.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_200.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Oh, that? I thought I told you. "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("Dateline NBC")]), _vm._v(" is going to feature us in a segment titled ‘Working Couples: Who Does the Brunt of the Housework?’”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_201.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Will you knock it off with the "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("Chicken Soup for the Soul")]), _vm._v(" excerpts!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_202.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Before we waste your time and mine, let’s see if \nyou can fit through this opening.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_203.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Hoping to catch some discreet Zees during the film in biology, Brian brings his head-prop and plastic eyeballs.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_204.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_205.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“OK, Bobby! You can open your eyes now!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_206.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Spotting some unexpected visitors coming up the walk, the Hadleys activated their hidden clean living room.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_207.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“No, the color of that tree clashes with Dad’s chair. Let’s head up the hill to that grove of Scotch pines and see if there are any suitable trees there.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_208.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("In a rare display of emotion, gym teacher Art Mankowski succumbs to the spirit of Christmas.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_209.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“You still want us to change the oil?”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_210.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Come on! Where’s your sense of humor? All I’m going to do is stroll her through the mall!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_211.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“I’m tellin’ ya, Louise, that’s the only thing that keeps me from going insane on rainy days.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_212.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Are you gonna whine, or are you gonna let me fix your back?!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_213.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“It’s very unlikely that you’ll ever need to use them, but if that red light comes on, start pedaling like crazy.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_214.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Uh, yeah, Homework Help Line? I need to have you explain \n  the quadratic equation in roughly the amount of time \nit takes to get a cup of coffee.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_215.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“See, you thought it was real! I tell ya, hologram Christmas trees are the way to go!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_216.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“We ran into some complications with your appendectomy.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_217.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_218.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_219.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_220.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Mrs. Killigrew, I’m sure I explained it to you \n  over the phone. It emits a crippling, high-pitched \n  squeal that "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("only thieves can hear")]), _vm._v(". Now if you’ll \njust sign at the bottom ...”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_221.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Before Ramona says ‘I do,’ Phil, she’d like you to \n  inspect this bathroom scene and make whatever \ncorrections you feel are needed.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_222.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_223.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Well, I’m sorry, but if you don’t have a receipt for the pacemaker there’s not much we can do for you.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_224.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Only a veteran mom can master the art of hands-free stroller unfolding.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_225.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“We tried flea dips, powders, and sprays.\nBut our vet finally convinced us that organic\nflea treatment was the way to go.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_226.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Carol sensed that the romance was slowly slipping from their marriage.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_227.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“We’ve already had endorsement offers from three shampoo companies.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_228.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_229.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_230.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“OK, ma’am, here’s how our Super Value tug-of-war works! You two battle it out for 60 seconds, and wherever the value arrow winds up is the price you walk away with!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_231.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“Well, no wonder! The tubes were switched!\nThis thing’s been running in reverse.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_232.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_233.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("Metal-shop teacher Hank Borgner prided himself in his back-to-basics curriculum.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_234.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("The new kinder, gentler IRS.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_235.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Well, we had her declawed but started feeling guilty that she couldn’t climb trees any longer. And then Frank saw this ad in the back of "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("Popular Mechanics ...")]), _vm._v("”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_236.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Oh, calm down, dear! No one’s looking! Just let me tweeze these little hairs you’ve got, so David doesn’t think he’s marrying Groucho Marx.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_237.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Another marketing success for the Postal Service.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_238.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“Oh, come on. Don’t be such a grouch! The kids worked so hard on it, and you’ll be able to see where you’re driving just fine.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_239.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Holy cow! "), _c('span', {
    staticClass: "GillSans-BoldItalic"
  }, [_vm._v("Now")]), _vm._v(" we’ve got a pulse!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_240.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Hey, I’ve had it with getting them in and out of winter clothes. This new flexible foam insulation goes on quickly and peels right off.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_241.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Life with a chronic article-clipper.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_242.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_243.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“If you want my opinion, this is all just a scam to get us to fork over $75 for graduation gown rentals!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_244.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Hey, the sooner he learns to crawl, the sooner he’ll learn to walk. The sooner he learns to walk, the sooner he can mow the lawn.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_245.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“OK, fine. So now you never have to shovel the driveway again. Explain to me how you’re going to keep the paper boy from catching on fire.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_246.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Essential training for expectant parents.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_247.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("At the funeral of the inventor of the jack-in-the-box.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_248.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“The salesman told me he caught 23 northern pikes in less than an hour while swimming in a pair of these.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_249.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("“And now, Dr. Johnson is going to juggle four syringes of Novocain while he simultaneously injects you with a fifth one!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_250.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap2"
  }, [_vm._v("A revolutionary breakthrough in driver education technology: Nerf cars.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_251.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("“Your carpal tunnel syndrome should clear up in\ntwo weeks, plus you’ll burn 500 calories an hour.”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_252.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_253.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“OK, there! I don’t want to hear anyone whining about how long it takes for the water to get hot!”")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_254.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("“It’s just a way of maintaining a sense of humor around here. Now if you’ll just clench your fist ...”")])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3698a512","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VCS_07.vue
// module id = 72
// module chunks = 0